/**
 * Minimal client-side JWT inspection helpers — payload decode + expiry checks ONLY.
 * No signature verification here (that's the server's job); these exist so clients can make
 * good-faith decisions like "don't hand over / persist an already-expired token" and
 * "schedule renewal before exp". Single source of truth for web (Studio) and ros-app.
 */

export function parseJwtPayload(token: string): Record<string, string> | null {
  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded)
  } catch {
    return null
  }
}

/** The token's `exp` as epoch milliseconds, or 0 when absent/unparseable. */
export function tokenExpMs(token: string): number {
  const exp = Number((parseJwtPayload(token) as Record<string, unknown> | null)?.exp)
  return Number.isFinite(exp) && exp > 0 ? exp * 1000 : 0
}

/** A JWT is usable if it has an `exp` in the future (with a small skew). Unparseable/expired → false. */
export function tokenStillValid(token: string): boolean {
  const expMs = tokenExpMs(token)
  return expMs > Date.now() + 5000
}
